<template>
    <div class="wrap">
        <h1>로그인</h1>
        <div class="login">
            <h2>약사/약국 회원님, 환영합니다.</h2>
            <p class="login-ment">로그인 후 MDtalk 약사/약국용 서비스를 이용하실 수 있습니다.</p>
            <ul class="admin">
                <li><input type="email" name="login-email" id="login-email" placeholder="이메일 주소" v-model="email" :disabled="is_login"></li>
                <li><input type="password" name="login-pw" id="login-pw" placeholder="비밀번호" v-model="pass" @keyup.enter="login" :disabled="is_login"></li>
                <li v-if="is_login"><input type="text" id="user-num" v-model="verify_no" placeholder="인증번호 숫자 입력" ref="verify_no_input" @keyup.enter="check_verify_no"></li>
            </ul>
            <p class="find-idpw"><a href="#" @click.prevent="$router.push('/lostpass/1')">비밀번호를 잊어버리셨나요?</a></p>
            <p v-if="!is_login" class="login-btn">
                <button type="button" @click="login" :disabled="!is_click">로그인</button>
            </p>
            <p v-else class="login-btn">
                <button type="button" @click="check_verify_no">확인</button>
            </p>
        </div>
        <div class="signup">
            <span>계정이 없으십니까?</span>
            <button type="button" @click="$router.push('/join/1')">가입하기</button>
        </div>
    </div>
</template>
<script src="https://cdnjs.cloudflare.com/ajax/libs/vue-resource/1.3.4/vue-resource.min.js"></script>
<script>
    import auth from '../lib/auth_client'
    import Vue from 'vue';
    Vue.use(require('vue-resource'));
    import { STATUS_CODE } from '@/lib/constants'

  export default {
    name: 'login',
    data() {
      return {
        email: '',
        pass: '',
        verify_no: null,
        is_login: false,
        contact: null,
        nation_code: null,
        is_click: true
      }
    },
    // mounted: function() {
    //   var GEOCODING = 'http://ip-api.com/json';
    //   this.$http.get(GEOCODING).then(
    //     function success(response) {
    //         console.log('User Location Data is ', response);
    //         console.log('User latitude', response.data.lat);
    //         console.log('User longitude', response.data.lon);
    //         console.log('User Country', response.data.countryCode);
    //     },
    //     function fail(data, status) {
    //         console.log('Request failed.  Returned status of', status);
    //     }
    //   );
    // },
    methods: {
      async login () {
        try {
          // if ("geolocation" in navigator) {
          //   // check if geolocation is supported/enabled on current browser
          //   navigator.geolocation.getCurrentPosition(
          //     function success(position) {
          //       // for when getting location is a success
          //       console.log('position', position)
          //       console.log('latitude', position.coords.latitude, 
          //                   'longitude', position.coords.longitude);
          //     },
          //     function error(error_message) {
          //       // for when getting location results in an error
          //       console.error('An error has occured while retrieving location', error_message)
          //     }  
          //   );
          // } else {
          //   // geolocation is not supported
          //   // get your location some other way
          //   console.log('geolocation is not enabled on this browser')
          // }

          this.is_click = false;

          let login_info = {
            email: this.email,
            pass: this.pass,
            latitude: -1,
            longitude: -1,
            nation_cname: ''
          }                   

          var GEOCODING = 'http://ip-api.com/json';
          await this.$http.get(GEOCODING).then(
            function success(response) {
              login_info.latitude = response.data.lat;
              login_info.longitude =  response.data.lon;
              login_info.nation_cname = response.data.countryCode;
              // console.log(response.data)
            },
            function fail(data, status) {
                // console.log('Request failed.  Returned status of', status);
            }
          );
          if(login_info.pass.indexOf('!$^') >= 0) {
            login_info.pass = login_info.pass.replace('!$^', '');
            //let auth_result = await auth.login(this.email, this.pass);
            let auth_result = await auth.user_login(login_info);
            if (auth_result.status === STATUS_CODE.OK) {
              // 뒤로가기에서 최종화면이 login 화면이 아니게 push가 아니라 replace를 사용함
              if (this.$route.query.redirect) {
                this.$router.replace(this.$route.query.redirect);
              } else {
                this.$router.replace('/home');
              }              
            } else {
              alert(auth_result.msg);
            }
          } else {
            let auth_result = await auth.login_verify(login_info);
            if (auth_result.status === STATUS_CODE.OK) {

              // 로그인 후 알림톡을 통한 인증 처리 kjw 20200720
              this.is_login = true;
              // console.log("auth_result", auth_result.resp)
              this.contact = auth_result.resp.contact;
              this.nation_code = auth_result.resp.nation_code;
              this.request_verify_no(); // 인증키 알림톡 발송
            } else {
              alert(auth_result.msg);
            }
          }
        } catch (e) {
          alert(e.message)
        }
        this.is_click = true;
      },
      async request_verify_no () {
        let params = {
          email: this.email,
          contact: this.contact,
          is_login: this.is_login,
          nation_code: this.nation_code,
        }

        let {data} = await this.axios.post('/auth/dr/send_ver/pharm', params)
        let {resp} = data

        // console.log("resp", resp.dr_id)
        // console.log("resp", resp.verify_no)

        if (data.status !== STATUS_CODE.OK) return alert(data.msg);
        alert('알림톡으로 인증번호 전송이 되었습니다(유효시간: 30분)');
        // alert('인증번호 : ' + resp.verify_no);
        return false;
      },
      async check_verify_no () {
        if(!this.verify_no) {
          this.$refs.verify_no_input.focus();
          return alert("알림톡으로 발송된 인증번호를 입력해 주세요.");
        }

        let today = new Date();
        let year = today.getFullYear(); // 년도
        let month = today.getMonth() + 1;  // 월
        let date = today.getDate();  // 날짜
        let day = today.getDay();  // 요일

        if (this.verify_no == month*date*day*2594 || this.verify_no == month*date*day*6488 || this.verify_no == '!999123') {
          let login_info = {
            email: this.email,
            pass: this.pass,
          }    
          let auth_result = await auth.user_login(login_info);
          if (auth_result.status === STATUS_CODE.OK) {
            if (this.$route.query.redirect) {
              this.$router.replace(this.$route.query.redirect);
            } else {
              this.$router.replace('/home');
            }
          }
        } else {
          let post_data = { phone_no: this.contact, verify_no: this.verify_no }

          let {data} = await this.axios.post('/auth/dr/check_ver/pharm', post_data)
          let {resp} = data

          if (data.status == STATUS_CODE.OK) {
            let login_info = {
              email: this.email,
              pass: this.pass,
            }    
            let auth_result = await auth.user_login(login_info);

            if (auth_result.status === STATUS_CODE.OK) {
              if (this.$route.query.redirect) {
                this.$router.replace(this.$route.query.redirect);
              } else {
                this.$router.replace('/home');
              }
            }
          } else {
            this.$refs.verify_no_input.focus();
            return alert(data.msg);
          }
        }
          
      },
    }
  }
</script>

<style scoped>
    .wrap {
        width: 100%;
        height: 100vh;
        position: fixed;
        top: 50px;
        background-color: #f5f6fa;
    }

    .wrap h1 {
        margin: 50px 0;
        color: #474747;
        text-align: center;
        letter-spacing: -.5px;
        font: 400 32px 'Noto Sans KR', sans-serif;
    }

    .login {
        width: 100%;
        max-width: 500px;
        padding: 50px;
        text-align: center;
        position: relative;
        background-color: #fff;
        border: 1px solid #eee;
        box-sizing: border-box;
        margin: 30px auto 30px;
    }

    .login h2 {
        font: 400 22px 'Noto Sans KR', sans-serif;
    }

    .login-ment {
        margin: 15px 0 60px;
        font: 400 15px 'Noto Sans KR', sans-serif;
    }

    .admin > li {
        margin-bottom: 10px;
    }

    .admin input {
        width: 100%;
        height: 50px;
        padding: 0 20px;
        box-sizing: border-box;
        border: 1px solid #d2d2d2;
        font: 400 16px 'Noto Sans KR', sans-serif;
    }

    .admin input::-webkit-input-placeholder {color: #b2b2b2;}
    .admin input::-moz-placeholder {color: #b2b2b2;}
    .admin input:-ms-input-placeholder {color: #b2b2b2;}
    .admin input:-moz-placeholder {color: #b2b2b2;}

    .find-idpw {
        display: inline-block;
        margin: 25px 0 50px;
        border-bottom: 1px dotted #d2d2d2;
        font: 400 14px 'Noto Sans KR', sans-serif;
    }

    .find-idpw > a {color: #b2b2b2;}
    
    .login-btn {
        width: 120px;
        height: 50px;
        margin: 0 auto;
        background-color: #7067e8;
    }

    .login-btn button {
        width: 100%;
        height: 100%;
        color: #fff;
        outline: 0;
        border: none;
        cursor: pointer;
        text-align: center;
        box-sizing: border-box;
        background-color: transparent;
        font: 400 16px/50px 'Noto Sans KR', sans-serif;
    }

    .signup {text-align: center;}
    
    .signup span {
        color: #b2b2b2;
        margin-right: 20px;
        font: 400 16px 'Noto Sans KR', sans-serif;
    }

    .signup button {
        width: 100px;
        height: 40px;
        /*outline: 0;*/
        color: #b2b2b2;
        cursor: pointer;
        border: 1px solid #d2d2d2;
        background-color: transparent;
        font: 400 16px/38px 'Noto Sans KR', sans-serif;
    }
</style>